/* eslint-disable */
import { useCallback, useContext, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import LoadingButton from '@mui/lab/LoadingButton';
import { alpha, useTheme, styled } from '@mui/material/styles';
import InputAdornment from '@mui/material/InputAdornment';
import Divider from '@mui/material/Divider';
import Avatar from '@mui/material/Avatar';

import { Alert, Button, Fade, Grid, Modal } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { apiUrl, serverUrl, postRequest } from '../utils/services';
import { useResponsive } from '../hooks/use-responsive';
import { bgGradient } from '../theme/css';
import Logo from '../components/logo';
import Iconify from '../components/iconify';
import { AuthContext } from '../context/AuthContext';


const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});
export default function ProfilePage() {

  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [buttonLoad, setButtonLoad] = useState(false);
  const { user, setUser } = useContext(AuthContext);
  
  const userId = user.id;
  const [updateError, setUpdateError] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(apiUrl+user.image);
  const [firstName, setFirstName] = useState(user.firstName);
  const [lastName, setLastName] = useState(user.lastName);
  const [email, setEmail] = useState(user.email);
  const [mobileNumber, setMobileNumber] = useState(user.mobileNumber);
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const userDetails = { ...user };

  const upLg = useResponsive('up', 'md');

  const handleProfileUpdate = async (e) => {
    setButtonLoad(true);
    e.preventDefault();

    const formData = new FormData();
    formData.append('firstName', firstName);
    formData.append('lastName', lastName);
    formData.append('email', email);
    formData.append('mobileNumber', mobileNumber);
    
    if (newPassword) {
      formData.append('newPassword', newPassword);
      formData.append('oldPassword', oldPassword);
    }

    if (selectedImage) {
      formData.append('image', selectedImage);
    }

    if (newPassword != '' && newPassword !== confirmPassword) {
      setUpdateError('new password and confirmpassword must be same');
      setButtonLoad(false);
      return;
    }

    try {

      const response = await postRequest(`${apiUrl}/users/editProfile/${userId}`, formData, user)
      console.log('response',response);
      if (response?.success) {

        localStorage.setItem("User", JSON.stringify(response.user));
        setUser(response.user);

        navigate('/chat')
      }
      else if (response?.error) {
        setUpdateError(response?.message.error);
        setButtonLoad(false);
      }
    } catch (error) {
      setButtonLoad(false);

      console.error('Error uploading image:', error);
    }

  }
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file);
    console.log(file);
    const reader = new FileReader();
    reader.onload = () => {
      setPreviewImage(reader.result);
    };
    reader.readAsDataURL(file);
  };



  const renderForm = (
    <Box sx={{ overflowY: 'auto' }}>
      <Box textAlign='center'>
        <Button
          component="label"
          role={undefined}
          variant="text"
          sx={{
            padding: "3px",
            margin: '10px',
            borderRadius: '100px',
            boxShadow: '0px 0px 10px'
          }}
          tabIndex={-1}
        >
          <Avatar
            src={previewImage}
            sx={{ width: 100, height: 100 }}
          />
          <VisuallyHiddenInput accept="image/*" type="file" onChange={handleImageChange} />
        </Button>
        <Typography fontSize='0.75rem' marginTop='15px' marginBottom='20px' color='rgb(145, 158, 171)'>
              Allowed *.jpeg, *.jpg, *.png, *.gif <br />
              max size of 3 Mb
            </Typography>
      </Box>
      <Grid container marginBottom={3} spacing={2}>
        <Grid item sm={6} xs={12} md={6} >
          <Box flex={1} p={1}>
            <TextField sx={{ width: '100%' }} name="firstName" label="First Name" value={firstName} onChange={((e) => setFirstName(e.target.value))} />
          </Box>
        </Grid>
        <Grid item sm={6} xs={12} md={6} >
          <Box flex={1} p={1}>
            <TextField sx={{ width: '100%' }} name="lastName" label="Last Name" value={lastName} onChange={((e) => setLastName(e.target.value))} />
          </Box>
        </Grid>
        <Grid item sm={6} xs={12} md={6} >
          <Box flex={1} p={1}>
            <TextField sx={{ width: '100%' }} name="email" label="Email address" value={email} onChange={((e) => setEmail(e.target.value))} />
          </Box>
        </Grid>

        <Grid item sm={6} xs={12} md={6} >
          <Box flex={1} p={1}>
            <TextField sx={{ width: '100%' }} name="mobileNumber" label="Mobile Number" value={mobileNumber} onChange={((e) => setMobileNumber(e.target.value))} />
          </Box>
        </Grid>
      </Grid>
      <Divider />
      <Grid container marginTop={1} marginBottom={3} spacing={2}>
        <Grid item sm={6} xs={12} md={6} >
          <Box flex={1} p={1}>
            <TextField
              name="newPassword"
              label="Old Password"
              sx={{ width: '100%' }}
              value={oldPassword}
              onChange={((e) => setOldPassword( e.target.value ))}
              type={showPassword ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                      <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Grid>
        <Grid item sm={6} xs={12} md={6} >
          <Box flex={1} p={1}>
            <TextField
              name="newPassword"
              label="New Password"
              sx={{ width: '100%' }}
              value={newPassword}
              onChange={((e) => setNewPassword(e.target.value ))}
              type={showPassword ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                      <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Grid>
        <Grid item sm={6} xs={12} md={6} >

          <Box flex={1} p={1}>

            <TextField
              name="confirmPassword"
              label="Confirm Password"
              value={confirmPassword}
              onChange={((e) => { setConfirmPassword(e.target.value ) })}
              sx={{ width: '100%' }}
              type={showPassword ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                      <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>

        </Grid>
      </Grid>

     
      {updateError&&<Alert sx={{marginBottom:3}} severity="error">{updateError}</Alert>}

     
      <Grid container marginTop={1} marginBottom={3} spacing={2}>
        <Grid item sm={6} xs={12} md={6} >
      <Button
        fullWidth
        size="large"
        type="submit"
        variant="outlined"
        color="inherit"
        onClick={()=>{navigate('/chat')}}
      >
        Cancel
      </Button>
      </Grid>
      <Grid item sm={6} xs={12} md={6} >

      <LoadingButton
        loading={buttonLoad}
        fullWidth
        size="large"
        type="submit"
        variant="contained"
        color="inherit"
        onClick={handleProfileUpdate}
      >
        Update
      </LoadingButton>
      </Grid>
      </Grid>

    </Box>
  );

  return (
      <Stack alignItems="center" justifyContent="center" sx={{ height: 1,p:1 }}>
        <Card
          sx={{
            p: upLg ? 5 : 2,
            width: 1,
            maxWidth: 620,
          }}
        >
          <Typography variant="h4" p='10px'> Edit Profile</Typography>
          {renderForm}
        </Card>
      </Stack>

  )
} 